var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableSendMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -0.5 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-mail-send",
    fill: "gray",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "795"), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.969,2.985 L8,0.032 L5.031,2.985 L7.016,2.985 L7.016,5.97 L8.953,5.97 L8.953,2.985 L10.969,2.985 Z",
    fill: "gray",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.062,2.094 L15.062,0.724 L8.014,6.344 L0.938,0.812 L0.967,2.094 L4.037,4.693 L0.848,9.046 L2.094,9.046 L4.956,5.569 L8.014,8.188 L11.022,5.643 L13.906,9.046 L15.17,9.031 L12.046,4.693 L15.062,2.094 Z",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.304,0.059 L10.062,0.059 L10.062,3.063 L5.959,3.063 L5.959,0.059 L0.701,0.059 C0.344,0.059 0.053,0.35 0.053,0.707 L0.053,9.324 C0.053,9.681 0.344,9.972 0.701,9.972 L15.304,9.972 C15.662,9.972 15.953,9.681 15.953,9.324 L15.953,0.707 C15.953,0.35 15.662,0.059 15.304,0.059 L15.304,0.059 Z M13.906,9.046 L11.022,5.643 L8.013,8.188 L4.955,5.57 L2.093,9.047 L0.847,9.047 L4.036,4.694 L0.966,2.094 L0.937,0.813 L8.013,6.344 L15.062,0.724 L15.062,2.094 L12.045,4.694 L15.169,9.032 L13.906,9.046 L13.906,9.046 Z",
    fill: "gray",
    className: "si-glyph-fill"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableSendMail);
export default __webpack_public_path__ + "static/media/disable-send-mail.c4e165cb4fa3e0c77a68cd524cdeea21.svg";
export { ForwardRef as ReactComponent };